
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import BasicApi from './index'
import Toast from '../component/common/toast/index'
import { getCookie } from '../assets/js/common'
import ConfigUrl from './configUrl'
const { loginUrl, wxServerUrl } = ConfigUrl

const utoken = () => {
  return {
    headers: {
      utoken: getCookie('utoken')
    }
  }
}

// 登录域名
// let url = ''

// if (process.env.NODE_ENV === 'development') {
//   // url = 'http://dev.passport2.makeblock.com'
//   url = '//passport-test.makeblock.com'
// }
// if (process.env.NODE_ENV === 'test') {
//   url = '//passport-test.makeblock.com'
// }
// if (process.env.NODE_ENV === 'production') {
//   url = '//passport2.makeblock.com'
// }

// 用户模块
class UserApi extends BasicApi {
  // 用户登录
  login (data) {
    return this.post(loginUrl + '/v1/user/login', data)
  }
  // 通过token获取用户信息
  getUserInfor () {
    return this.post(loginUrl + '/v1/user/getbyutoken', {}, utoken())
  }
  // 个人学习信息
  getLearnInfor (boxid) {
    return this.get(`/api/user/box/${boxid}`, utoken())
  }
  // 老师微信二维码
  teacherWxQrCode () {
    return this.get(wxServerUrl + '/v1/api/user/info', utoken())
  }
  // 通知家长
  notifyUser (boxid) {
    return this.get(`/api/weixin/box/buy/${boxid}`, utoken())
  }
}

const userApi =  new UserApi()

userApi.$http.interceptors.response.use(response => {
  // Do something with response data
  // console.log(response)
  if (response.data.code > 0){
    // if (response.data.code === 10111) {
    //   localStorage.removeItem('utoken')
    // }
    // Toast.error(response.data.message)
    console.log(response.data.message)
  }
  return response;
}, error => {
  // Do something with response error
  // console.log(error.response)
  if (error.response) {
    console.log(error.response.data)
    Toast.error(error.response.data)
  } else {
    const data = error.message
    if (data === 'Network Error') {
      Toast.error('网络异常，请稍后重试')
      // console.log('网络异常，请稍后重试');
    } else {
      console.log(error.message);
      Toast.error(error.message)
    }
  }
  return Promise.reject(error);
});

export default userApi